import { Switch } from 'react-router-dom'
import { compose } from '@cbgms/base/utils/compose'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import List from './List'
import { ShopIDToCompanyRedirect } from './ShopIDToCompanyRedirect'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_SHOPS } from 'app-support/permissions/Permissions'
import { shopsRoute, shopsTabRoute } from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler(shopsRoute))

export const ShopContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_SHOPS} exact path={shopsRoute} component={List} />
    <PermissionRoute permission={PERMISSION_MANAGE_SHOPS} exact path={shopsTabRoute} component={ShopIDToCompanyRedirect} />
  </Switch>
)

export default enhance(ShopContainer)
